// extracted by mini-css-extract-plugin
module.exports = {"Appointments":"Appointments_Appointments__1UUyP","appointmentsTitle":"Appointments_appointmentsTitle__mGKvy","appointmentsTable":"Appointments_appointmentsTable__2J8Kv"};